import Vue from 'vue';
import { Component, Provide } from 'vue-property-decorator';

@Component
export default class HasSideDrawerMixin extends Vue {
  @Provide('sideDrawer')
  sideDrawer: boolean = null;

  @Provide('toggleSideDrawer')
  toggleSideDrawer() {
    this.sideDrawer = !this.sideDrawer;
  }
}
